import { render, staticRenderFns } from "./list-menu-reboquista.vue?vue&type=template&id=e3f9bdb2&"
import script from "./list-menu-reboquista.vue?vue&type=script&lang=js&"
export * from "./list-menu-reboquista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports